// Auto-generated build version — updated by post-build.cjs
export const BUILD_VERSION = "07.08.2026, 17:19:39";
export const BUILD_TIMESTAMP = "2026-08-07T15:19:39.028Z";
